module.exports = __webpack_public_path__ + "img/bj.65cd25c7.jpg";